export interface BatteryReplacement {
  dcode?: number;
  acode?: number;
  BR_Status?: number; // Waiting for sync(0); Synced(1)
  BR_Date?: number;
  BR_Months?: number;
  BR_Enable?: boolean;
  BR_Date_Format?: Date;
  BR_Rc_Date?: number;
  expires?: boolean;
}

export interface BtyReplacementParams {
  otp?: string;
  acode?: number;
  dcode?: number;
  getAll?: boolean;
  RegionIds?: any[];
}
